<div class="container">
  <div *ngIf="isLoadSubmitButton" class="charge-wallet">
    <div class="charge-form">
      <div class="title flex pointer" (click)="onBack()">
        <img src="assets/images/icons/left-arrow.svg" alt="Arrow Left Icon" />
        <p>Top Up</p>
      </div>
      <form [formGroup]="orderForm" (ngSubmit)="onSubmitOrderForm()">
        <div class="charge-amount-container">
          <div class="suggested-amount-list">
            <button
              class="suggest-button"
              type="button"
              (click)="onSuggestedAmountClick(20, 1)"
              [class.selected-suggest-button]="selectedSuggestedAmount == 1"
            >
              $20
            </button>
            <button
              class="suggest-button"
              type="button"
              (click)="onSuggestedAmountClick(50, 2)"
              [class.selected-suggest-button]="selectedSuggestedAmount == 2"
            >
              $50
            </button>
            <button
              class="suggest-button"
              type="button"
              (click)="onSuggestedAmountClick(100, 3)"
              [class.selected-suggest-button]="selectedSuggestedAmount == 3"
            >
              $100
            </button>
            <button
              class="suggest-button"
              type="button"
              (click)="onSuggestedAmountClick(150, 4)"
              [class.selected-suggest-button]="selectedSuggestedAmount == 4"
            >
              $150
            </button>
            <button
              class="suggest-button"
              type="button"
              (click)="onSuggestedAmountClick(200, 5)"
              [class.selected-suggest-button]="selectedSuggestedAmount == 5"
            >
              $200
            </button>
            <button
              class="suggest-button"
              type="button"
              (click)="onSuggestedAmountClick(500, 6)"
              [class.selected-suggest-button]="selectedSuggestedAmount == 6"
            >
              $500
            </button>
          </div>
          <div class="amount-input flex">
            <label for="amount">Desired Amount</label>
            <input
              type="text"
              name=""
              id="amount"
              formControlName="amount"
              type="number"
              onlyNumbers
              pattern="[0-9]*"
              placeholder="$50-500"
            />
          </div>
        </div>
        <div class="payment-method-select">
          <p class="payment-title">How would you like to make payment?</p>
          <mat-radio-group class="radio-group" formControlName="gateway">
            <ng-container *ngFor="let gatewayItem of gatewayList">
              <mat-radio-button
                class="radio-button"
                [value]="gatewayItem"
                *ngIf="gatewayItem.can_use_for_wallet"
              >
                <img [src]="gatewayItem?.logo" *ngIf="gatewayList?.logo" />
                <p>{{ gatewayItem?.title }}</p>
              </mat-radio-button>
            </ng-container>
          </mat-radio-group>
        </div>
      </form>
    </div>
    <div class="info-item" *ngIf="processingFee">
      <div class="item-title">
        Processing Fee
        <!-- ({{ processingFee }}%): -->
      </div>
      <div class="item-value">
        {{ payableCurrency }}{{ processingFee | convertPrice }}
      </div>
    </div>
    <div class="final-payment-detail flex">
      <div class="payable-amount flex">
        <p class="flex">
          <span class="title">Payable Amount:</span>
          <span class="amount flex" *ngIf="payableAmount">
            <span>{{ payableCurrency }}</span>
            <span>{{ payableAmount | convertPrice }}</span>
          </span>
          <span class="amount" *ngIf="!payableAmount">$0.00</span>
        </p>
      </div>

      <button
        class="button primary-button buy-button"
        type="submit"
        (click)="onSubmitOrderForm()"
        [class.disabled]="!orderForm.valid || checkBitPay == false"
      >
        Buy Now
      </button>
    </div>
  </div>
  <div class="custom-gateway card" *ngIf="!isLoadSubmitButton">
    <ngx-paypal [config]="payPalConfig"></ngx-paypal>
  </div>
</div>

<ng-template #customerCardListDialog>
  <div *ngIf="customerCardList?.length == 0">
    <p>{{ 'paymentPage.noCards' | translate }}</p>
    <br />
  </div>
  <div class="card-number-list" *ngIf="customerCardList?.length > 0">
    <h3>{{ 'paymentPage.selectCard' | translate }}</h3>
    <br />
    <div class="card-list-container">
      <a *ngFor="let card of customerCardList" (click)="selectCard(card)">
        <div class="bank-card">
          <p>{{ card.card_number }}</p>
        </div>
      </a>
    </div>
  </div>
  <button mat-button (click)="addCard()" class="add-btn">
    {{ 'paymentPage.addCard' | translate }}
  </button>
</ng-template>

<ng-template #verify let-data>
  <div class="verify-dialog">
    <p>{{ 'paymentPage.confirm' | translate }}</p>
    <br />
    <p class="bank-card">{{ data.card_number }}</p>
    <br />
    <div class="btn-container">
      <button
        mat-raised-button
        mat-dialog-close
        (click)="selectMethodId(data.payment_method_id)"
        class="verify-btn"
      >
        {{ 'paymentPage.yes' | translate }}
      </button>
      <button mat-stroked-button mat-dialog-close class="stroked">
        {{ 'paymentPage.no' | translate }}
      </button>
    </div>
  </div>
</ng-template>
